import { render, staticRenderFns } from "./LandingSimple.vue?vue&type=template&id=73450100&scoped=true"
import script from "./LandingSimple.vue?vue&type=script&lang=js"
export * from "./LandingSimple.vue?vue&type=script&lang=js"
import style0 from "./LandingSimple.vue?vue&type=style&index=0&id=73450100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73450100",
  null
  
)

export default component.exports